module.exports = __webpack_public_path__ + "img/paket.424d5ad7.png";